import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// =========================================================================
// ⚙️ CONFIGURACIÓN DE FIREBASE
// =========================================================================
// ⚠️ IMPORTANTE: Recuerda poner aquí tus claves reales antes de compilar
const MIO_FIREBASE_CONFIG = {
			apiKey: "AIzaSyA3js2JuMnZTZ0hcMrHIiSMq252KnMC7lI",
			authDomain: "abltorneos.firebaseapp.com",
			projectId: "abltorneos",
			storageBucket: "abltorneos.firebasestorage.app",
			messagingSenderId: "514954633398",
			appId: "1:514954633398:web:d0ad728cbe61a51c758617"
};

export const APP_ID_INTERNO = 'liga-alicantina-v1';

const app = initializeApp(MIO_FIREBASE_CONFIG);
export const auth = getAuth(app);
export const db = getFirestore(app);